import { MealPhotoQueueResponse } from '@/api/generated/MNT';
import { useAuthenticatedBlobQuery } from '@/components/AuthenticatedImage';
import { ImageError } from '@/components/ImageError';
import { useMealPhotoUrl } from '@/pages/QueueItem/meal-builder/mealPhotoUrl';

const mediaClassName = 'h-queue-image w-queue-image rounded-auditor object-cover';

export const PreviewImage = (props: { queueItem: MealPhotoQueueResponse; size?: 'resized' | 'original' }) => {
  const photoUrl = useMealPhotoUrl(props.queueItem, props.size ?? 'original');
  const img = useAuthenticatedBlobQuery(photoUrl);

  return !img.src ? (
    <ImageError className={mediaClassName} />
  ) : (
    <img alt="" src={img.src} width={90} height={80} className={mediaClassName} />
  );
};
